export { default as ReplySolidIcon } from './ReplySolidIcon';
